import { RecoveryPage } from './routes/recovery-page';
import { PassPage } from './routes/pass-page';
import { HelpPage } from './routes/help-page';
import { NotesPrintPage } from './routes/notes-print-page';
import { ScoresPage } from './routes/scores-page';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import { AppShell } from './app-shell';
import { NotFoundPage } from './error-boundary';

const LogsPage = lazy(async () => ({ default: (await import('./routes/logs-page')).LogsPage }));
const HomePage = lazy(async () => ({ default: (await import('./routes/home-page')).HomePage }));
const NewLogPage = lazy(async () => ({ default: (await import('./routes/logs-page')).NewLogPage }));
const NotesPage = lazy(async () => ({ default: (await import('./routes/notes-page')).NotesPage }));
const ReportPage = lazy(async () => ({
  default: (await import('./routes/report-page')).ReportPage,
}));
const AchievementsPage = lazy(async () => ({
  default: (await import('./routes/achievements-page')).AchievementsPage,
}));
const PlanPage = lazy(async () => ({ default: (await import('./routes/plan-page')).PlanPage }));
const ReviewPage = lazy(async () => ({
  default: (await import('./routes/review-page')).ReviewPage,
}));
const TodaySessionPage = lazy(async () => ({
  default: (await import('./routes/today-session-page')).TodaySessionPage,
}));
const RoomsPage = lazy(async () => ({ default: (await import('./routes/rooms-page')).RoomsPage }));
const SettingsPage = lazy(async () => ({
  default: (await import('./routes/settings-page')).SettingsPage,
}));
const DataPage = lazy(async () => ({ default: (await import('./routes/data-page')).DataPage }));
const RemindersPage = lazy(async () => ({
  default: (await import('./routes/reminders-page')).RemindersPage,
}));
const OnboardingPage = lazy(async () => ({
  default: (await import('./routes/onboarding-page')).OnboardingPage,
}));
const GuidesPage = lazy(async () => ({
  default: (await import('./routes/guides-page')).GuidesPage,
}));
const PrivacyPage = lazy(async () => ({
  default: (await import('./routes/privacy-terms-support-routes')).PrivacyPage,
}));
const TermsPage = lazy(async () => ({
  default: (await import('./routes/privacy-terms-support-routes')).TermsPage,
}));
const SupportPage = lazy(async () => ({
  default: (await import('./routes/privacy-terms-support-routes')).SupportPage,
}));

function RouteLoading() {
  return (
    <p className="pn-policy-note" role="status">
      화면을 불러오는 중이에요…
    </p>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteLoading />}>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<HomePage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="logs/new" element={<NewLogPage />} />
            <Route path="notes" element={<NotesPage />} />
            <Route path="notes/new" element={<NotesPage create />} />
            <Route path="notes/print" element={<NotesPrintPage />} />
            <Route path="report" element={<ReportPage />} />
            <Route path="scores" element={<ScoresPage />} />
            <Route path="achievements" element={<AchievementsPage />} />
            <Route path="plan" element={<PlanPage />} />
            <Route path="review" element={<ReviewPage />} />
            <Route path="today-session" element={<TodaySessionPage />} />
            <Route path="rooms" element={<RoomsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="pass" element={<PassPage />} />
            <Route path="help" element={<HelpPage />} />
            <Route path="recovery" element={<RecoveryPage />} />
            <Route path="settings/data" element={<DataPage />} />
            <Route path="settings/reminders" element={<RemindersPage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="guides/:slug" element={<GuidesPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
